import React from 'react';
import { Loader2, CheckCircle2, XCircle, X, RefreshCw } from 'lucide-react';

export const ResyncJobBanner = ({ job, onDismiss }) => {
  if (!job) return null;
  const running = job.status === 'queued' || job.status === 'running';
  const pct = job.total_found > 0 ? Math.round((job.processed / job.total_found) * 100) : 0;
  const tone = job.status === 'failed' ? 'border-red-200 bg-red-50' : job.status === 'completed' ? 'border-emerald-200 bg-emerald-50' : 'border-sky-200 bg-sky-50';

  return (
    <div className={`flex items-center gap-3 px-4 py-2.5 rounded-lg border mb-4 ${tone}`} data-testid="resync-job-banner">
      {running ? <Loader2 className="w-4 h-4 animate-spin text-sky-600 flex-shrink-0" />
        : job.status === 'completed' ? <CheckCircle2 className="w-4 h-4 text-emerald-600 flex-shrink-0" />
        : <XCircle className="w-4 h-4 text-red-600 flex-shrink-0" />}
      <div className="min-w-0 flex-1">
        <p className="text-xs font-semibold text-neutral-800 flex items-center gap-1.5">
          <RefreshCw className="w-3 h-3" /> Live Catalog Resync — {job.collectionName}
        </p>
        <p className="text-[11px] text-neutral-600 truncate" data-testid="resync-job-progress">{job.progress}</p>
        {running && job.total_found > 0 && (
          <div className="mt-1 h-1 bg-white/70 rounded-full overflow-hidden">
            <div className="h-full bg-sky-500 transition-all" style={{ width: `${pct}%` }} />
          </div>
        )}
      </div>
      {!running && (
        <button onClick={onDismiss} className="p-1 rounded hover:bg-white/60" data-testid="resync-job-dismiss"><X className="w-3.5 h-3.5 text-neutral-500" /></button>
      )}
    </div>
  );
};

export default ResyncJobBanner;
